import type { RootState } from 'src/app/store/types';

export const selectNumberOfDispatchCalendarFiltersApplied = (
  state: RootState
) => {
  const { drivers, vehicleTags, driverTags, statuses, payers, spaceTypes } =
    state.dispatcher.dispatchCalendarFilters;
  return (
    drivers.length +
    vehicleTags.length +
    driverTags.length +
    statuses.length +
    payers.length +
    spaceTypes.length
  );
};
